export default __webpack_public_path__ + "static/media/gvcCoffee.675369f6.jpg";